import i18n from '@/i18n';

const PageAlerts = () =>
  import(/* webpackChunkName: "alerts" */ '@/pages/hypervision/Alerts.vue');

const AlertsTop = () =>
  import(/* webpackChunkName: "alerts" */ '@/pages/hypervision/AlertsTop.vue');
const AlertsFilter = () =>
  import(
    /* webpackChunkName: "alerts" */ '@/pages/hypervision/AlertsFilter.vue'
  );

export const ALERTS_LIST_ROUTE_NAME = 'alerts-list';

export default {
  getAlertsRouter() {
    return {
      path: 'alerts',
      name: ALERTS_LIST_ROUTE_NAME,
      components: {
        top: AlertsTop,
        'right-drawer': AlertsFilter,
        default: PageAlerts,
      },
      meta: {
        authorizations: ['isMy360'],
        isHidden: false,
        title: 'alerts',
        icon: i18n.t('message.alerts.icon'),
      },
    };
  },
};
